import { produce } from 'immer'
import { getPages } from '@xiaoduo/x-data/utils'
import { StoryType, WorkflowType } from './components/StoryModal/const'
import * as services from './service'
import { formatValues } from '@/pages/admit/train/util'

export interface GroupType {
  id: string
  name: string
  sub_groups: GroupType[]
  parent_id: string
  group_id: string
  title: string
  group: GroupType
}

export type GroupsType = GroupType[]

export type PageInfoType = {
  last_page: number
  page_num: number
  page_size: number
  total: number
}

export type StroiesType = StoryType[]

export type StroyListType = {
  page: PageInfoType
  stories: StroiesType
}

export type StorySearchParamsType = {
  name?: string
  creator?: string
  story_group_id?: string
  story_group_ids?: string[]

  create_begin_time?: string
  create_end_time?: string
  modify_begin_time?: string
  modify_end_time?: string
  story_source?: number // 来源类型 1:自定义创建 2:热门商品 3:会话案例

  page: {
    is_descending?: boolean
    order_by?: string
    page_num?: number
    page_size?: number
    search_key?: string
  }
}

export const defaultStorySearch: StorySearchParamsType = {
  name: undefined,
  creator: undefined,
  story_group_id: undefined,

  create_begin_time: undefined,
  create_end_time: undefined,
  modify_begin_time: undefined,
  modify_end_time: undefined,
  story_source: undefined,

  page: {
    page_num: 1,
    page_size: 20,
    is_descending: undefined,
    order_by: undefined,
    search_key: undefined,
  },
}

type GenerateStatusType = {
  progress: number // 生成进度[0,100]
  story_total: number // 生成剧本数量
  task_total: number //生成任务数量，可能为0
}

export type DissatisfiedRebuildReq = {
  dissatisfied_type: number
  dissatisfied_reason: string
}

export type ProcessType = {
  order: number
  name: string
  demand: string
}

export type RebuildStoryType = {
  story_id: string
  dissatisfied: DissatisfiedRebuildReq[]
  content: string
  build_type: number
  work_flow: ProcessType[]
  handleReqStatusError: boolean // 为true时响应拦截不抛出错误
}

export type RebuildAiType = {
  dialog_result_id: string
  dissatisfied: DissatisfiedRebuildReq
  build_type: number
}

export type MockMsgsType = {
  type: number
  msg: string
  index: number
}

export type MockGoodsType = {
  goods_id: string
  goods_name: string
  tags?: string[]
  goods_url: string
  pic_url: string
  plat_classify?: string
  status?: string
}

export type MockStoryType = {
  role_id?: number //试用剧本的时候选择的角色：门店导购、电商客服啥的
  id?: string
  story_source: number
  group_id: string
  name: string
  buyer_context: string
  story_type: string
  evaluate_switch?: boolean
  quality?: boolean
  norm_platform?: string
  norm_id?: string
  process?: string
  work_flow: WorkflowType[]
}

export type MockType = {
  story: MockStoryType
  msgs?: MockMsgsType[]
  Goods?: MockGoodsType[]
}
export type HotGoodsType = {
  goods_id: string
  goods_name: string
  tags: string[]
  goods_url: string
  pic_url: string
  plat_classify: string
  status: number
  platform: string
  shop_name: string
}

export interface ModelState {
  caseList: any
  groupList: GroupsType
  groupId: string
  generateStory: any
  storyList: StroiesType
  storyTotal: number
  storySearch: StorySearchParamsType
  generateId: string // 生成剧本任务的id
  generateStatus: GenerateStatusType
  generateModalVisible: boolean // 生成弹窗是否显示
  completeModalVisible: boolean // 完成弹窗是否显示
  loading: boolean // 是否正在生成剧本
  isSuccess: boolean //成功新建剧本的弹窗
  vocHotGoodsList: HotGoodsType[]
}

const defaultGenerateStatus: GenerateStatusType = {
  progress: 0,
  story_total: 0,
  task_total: 0,
}

export const DEFAULT_ID = '000000000000000000000000'

// 模拟进度
const progressTask = function* (put, delay = 500) {
  let percent = 0
  while (percent < 90) {
    yield new Promise((resolve) => setTimeout(resolve, delay))
    percent += Math.floor(Math.random() * 11)
    yield put({
      type: 'updateCreateStoryPercent',
      payload: percent,
    })
  }
  yield new Promise((resolve) => {})
}

// 请求完成进度=100
const taskFinish = function* (put, result) {
  yield put({
    type: 'updateCreateStoryPercent',
    payload: 100,
  })
  yield new Promise((resolve) => setTimeout(resolve, 500))

  return result
}
const UserModel = {
  namespace: 'storyGroups',

  state: {
    groupList: [],
    caseList: [],
    generateStory: [],
    groupId: DEFAULT_ID,
    storyList: [],
    storyTotal: 0,
    storySearch: defaultStorySearch,
    generateId: '',
    generateStatus: {
      progress: 0,
      story_total: 0,
      task_total: 0,
    },
    generateModalVisible: false,
    completeModalVisible: false,
    loading: false,
    isSuccess: false,
    storyNum: 0,
    // 生成剧本的百分比
    createStoryPercent: 0,
    vocHotGoodsList: [],
    videopicfileList: [], // 上传的视频图片文件列表
    dialogRebuildType: {},
  },

  subscriptions: {
    setup: ({ dispatch, history }) => {
      return history.listen(({ pathname }) => {
        if (pathname === '/bank/story') {
          dispatch({
            type: 'fetchGroups',
            payload: {},
          })
        }
      })
    },
  },

  effects: {
    *getGenerateStory({ payload }, { call, put }) {
      yield put({
        type: 'setState',
        payload: {
          generateStory: payload,
        },
      })
    },
    *checkRepeatName({ payload }, { call, put }) {
      const response = yield call(services.checkRepeatName, payload)
      return response
    },
    // 获取案例内容
    *getCaseGroups({ payload }, { call, select, put }) {
      const response = yield call(services.getCaseGroups)
      yield put({
        type: 'setState',
        payload: {
          caseList: formatValues(response?.data?.groups),
        },
      })
    },
    *fetchGroups({ payload }, { call, put, select }) {
      const response = yield call(services.fetchGroups)
      yield put({
        type: 'setState',
        payload: { groupList: response.data.groups || [] },
      })
    },

    *createGroup({ payload }, { call, put }) {
      const result = yield call(services.createGroup, payload)
      yield put({ type: 'fetchGroups' })
      return result
    },

    *deleteGroup({ payload }, { call, put }) {
      const result = yield call(services.deleteGroup, payload)
      yield put({ type: 'fetchGroups' })
      return result
    },

    *deleteGroups({ payload }, { call, put }) {
      const result = yield call(services.deleteGroups, payload)
      yield put({
        type: 'setState',
        payload: {
          groupId: DEFAULT_ID,
        },
      })
      yield put({ type: 'fetchGroups' })
      return result
    },

    *updateGroup({ payload }, { call, put }) {
      const result = yield call(services.updateGroup, payload)
      yield put({ type: 'fetchGroups' })
      return result
    },

    *dropGroup({ payload }, { call, put }) {
      const result = yield call(services.dropGroup, payload)
      yield put({ type: 'fetchGroups' })
      return result
    },

    *createStory({ payload: params }, { call, put, race }) {
      try {
        const { simulateProgress = false, ...payload } = params
        let result
        if (simulateProgress) {
          yield put({ type: 'updateCreateStoryPercent', payload: 0 })
          // 并行执行实际的请求和进度模拟，使用 race
          const { response } = yield race({
            response: call(services.createStory, payload), // 发出请求
            progress: call(() => progressTask(put, 1)), // 继续模拟进度
          })
          if (response) {
            result = yield call(() => taskFinish(put, response))
          }
        } else {
          result = yield call(services.createStory, payload)
          yield put({ type: 'fetchStories' })
        }
        yield put({
          type: 'setState',
          payload: {
            storyNum: result?.data?.total,
          },
        })
        return result
      } catch (err) {
        // 暴露error
        console.log('createStory-error——', err)
        yield put({ type: 'updateCreateStoryPercent', payload: 0 })
      }
    },

    *fetchStories(_, { call, put, select }) {
      const { storySearch: params, groupId } = yield select((store) => store.storyGroups)
      const result = yield call(services.fetchStories, {
        ...params,
        story_group_id: groupId,
      })
      yield put({
        type: 'setState',
        payload: {
          storyList: result?.data?.stories || [],
          storyTotal: result?.data?.page?.total,
        },
      })
      return result
    },

    *updateStory({ payload }, { call, put }) {
      const result = yield call(services.updateStory, payload)
      return result
    },

    *deleteStory({ payload }, { call, put }) {
      const result = yield call(services.deleteStory, payload)
      return result
    },

    *moveStory({ payload }, { call, put }) {
      const result = yield call(services.moveStory, payload)
      return result
    },

    *reset(_, { put }) {
      yield put({
        type: 'setState',
        payload: { groupId: DEFAULT_ID, storySearch: defaultStorySearch },
      })

      yield put({ type: 'fetchStories' })
    },

    *addScreenplay({ payload: params }, { call, put, race }) {
      const { simulateProgress = false, ...payload } = params
      try {
        let result
        // 模拟请求进度
        if (simulateProgress) {
          yield put({ type: 'updateCreateStoryPercent', payload: 0 })
          // 并行执行实际的请求和进度模拟，使用 race
          const { response } = yield race({
            response: call(services.addScreenplay, payload), // 发出请求
            progress: call(() => progressTask(put, 500)), // 继续模拟进度
          })
          if (response) {
            result = yield call(() => taskFinish(put, response))
          }
        } else {
          result = yield call(services.addScreenplay, payload)
        }
        yield put({
          type: 'setState',
          payload: {
            storyNum: result?.data?.total,
          },
        })
        return result
      } catch (err) {
        // 暴露error
        console.log('addScreenplay-error', err)
        yield put({ type: 'updateCreateStoryPercent', payload: 0 })
      }
    },

    *generateStory(_, { call, put }) {
      const result = yield call(services.generateStory)
      if (!result?.data?.operation_id) return

      yield put({
        type: 'setState',
        payload: {
          generateId: result.data.operation_id,
        },
      })
      yield put({ type: 'startGenerate' })
    },

    *startGenerate(_, { call, select, put }) {
      const { generateId } = yield select((store) => store.storyGroups)
      yield call(services.generateStart, { operation_id: generateId })
    },

    *fetchProgress(_, { call, put, select }) {
      const { generateId } = yield select((store) => store.storyGroups)
      const result = yield call(services.getGenerateProgress, { OperationId: generateId })
      yield put({
        type: 'setState',
        payload: {
          generateStatus: {
            progress: result?.data?.progress || 0,
            story_total: result?.data?.story_total || 0,
            task_total: result?.data?.task_total || 0,
          },
        },
      })
    },

    *rebuildStoryContent({ payload }, { call }) {
      const result = yield call(services.rebuildStoryContent, payload)
      return result
    },

    *rebuildAiMentor({ payload }, { call }) {
      const result = yield call(services.rebuildAiMentor, payload)
      return result
    },
    *getStreamResult({ payload }, { call }) {
      const result = yield call(services.getStreamResult, payload)
      return result
    },
    // 获取商品详细信息
    *fetchGoodsDetail({ payload }, { call, put }) {
      const result = yield call(services.fetchGoodsDetail, payload)
      return result
    },

    *mockReception({ payload }, { call, put }) {
      const result = yield call(services.mockReception, payload)
      return result
    },
    // 获取商品平台
    *fetchPlatforms({ payload }, { call, put }) {
      const result = yield call(services.fetchPlatforms, payload)
      return result
    },
    // 查询voc热门商品
    *inquireVocHotGoods({ payload }, { call, put }) {
      const result = yield call(services.inquireVocHotGoods, payload)
      yield put({
        type: 'setState',
        payload: {
          vocHotGoodsList: result.data,
        },
      })
      return result
    },
    // voc案例筛选
    *vocCaseSelect({ payload }, { call, put }) {
      const result = yield call(services.vocCaseSelect, payload)
      return result
    },
    // voc案例筛选进度查询
    *vocCaseSelProgress({ payload }, { call, put }) {
      const result = yield call(services.vocCaseSelProgress, payload)
      return result
    },
    // 获取商品店铺
    *fetchShops({ payload }, { call, put }) {
      const result = yield call(services.fetchShops, payload)
      return result
    },
    // voc案例展示
    *showVocCase({ payload }, { call, put }) {
      const result = yield call(services.showVocCase, payload)
      return result
    },
    *setSimulatedOrders({ payload }, { call, put }) {
      const result = yield call(services.setSimulatedOrders, payload)
      return result
    },
    *parsePic({ payload }, { call, put }) {
      const result = yield call(services.parsePic, payload)
      return result
    },
    *saveResource({ payload }, { call, put }) {
      const result = yield call(services.saveResource, payload)
      return result
    },
    *queryResource({ payload }, { call, put }) {
      const result = yield call(services.queryResource, payload)
      const files = result?.data.files
      const ACCEPT_IMAGE = '.gif,.jpeg,.jpg,.png,.webp,.jfif'

      yield put({
        type: 'setState',
        payload: {
          videopicfileList: files.map((i) => {
            const fileType = i?.url?.substr(i?.url?.lastIndexOf('.'))?.toLowerCase() // 获取文件后缀名
            const isImg = ACCEPT_IMAGE.includes(fileType) || ACCEPT_IMAGE.includes(i?.file_type)
            return {
              business_id: i.business_id,
              business_type: i.business_type,
              id: i?.id,
              url: i.url,
              desc: i.desc,
              file_type: i.file_type,
              file_size: i.file_size,
              file_name: i.file_name,
              isImg,
            }
          }),
        },
      })
      return result
    },
  },
  reducers: {
    setState: produce((state, action) => ({
      ...state,
      ...action.payload,
    })),
    resetSearch: produce((state) => {
      state.storySearch = defaultStorySearch
    }),
    resetGenerate: produce((state) => {
      state.generateId = ''
      state.generateStatus = {
        ...defaultGenerateStatus,
      }
      state.generateModalVisible = false
      state.completeModalVisible = false
    }),
    // 更新生成剧本的进度
    updateCreateStoryPercent(state, { payload }) {
      return {
        ...state,
        createStoryPercent: payload,
      }
    },
  },
}

export default UserModel
